import * as React from 'react';
import LazyLoad from 'react-lazyload';
import { UitkCardContentSection } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { classNames } from 'uitk-react-utils';
import { ImageBadges } from '../..';
import { ActivityDestinationViewSearch } from '../../../../../../common/__generated__/api';
import { getPageId } from '../../../../../../helpers/common-helper';
import { useStores } from '../../../../../../utils/hooks/useStores';
import { FavoriteButton } from '../../../../../common/favorite-button';
import { ActivitySpannedTileCardTitle } from './activity-spanned-tile-card-title';

export interface ActivitySpannedTileCardImageProps {
  activity: ActivityDestinationViewSearch.ActivityInlineFragment;
  activityGroup?: string;
  isVerticalLayout: boolean;
  isInCarousel?: boolean;
  titleLines?: number;
}

export const ActivitySpannedTileCardImage: React.FC<ActivitySpannedTileCardImageProps> = ({
  activity,
  activityGroup,
  isVerticalLayout,
  isInCarousel,
  titleLines
}) => {
  const { activitySearchStore, shortlistStore } = useStores();
  const badges = activity?.badges;
  const pageId = getPageId(activitySearchStore);

  return (
    <>
      <UitkLayoutPosition
        className={classNames({ 'uitk-flat-border-left': activity.features.pinnedTopBottom })}
        type="relative"
      >
        {isVerticalLayout
          ? badges && <ImageBadges badges={badges} isVerticalLayout={isVerticalLayout} />
          : badges?.primary && <ImageBadges badges={{ primary: badges.primary }} isVerticalLayout={isVerticalLayout} />}
        <UitkFigure ratio={isVerticalLayout ? UitkFigureAspectRatioType.R16_9 : UitkFigureAspectRatioType.R4_3}>
          <LazyLoad height="100%" offset={[100, 100]} once>
            <UitkImage alt={activity.image?.description} src={activity.image?.url} />
          </LazyLoad>
          <UitkLayoutPosition type="absolute" position={{ top: 'one', right: 'one', zindex: 'layer3' }} cloneElement>
            <FavoriteButton
              activityId={activity.id}
              activityName={activity.name}
              page={pageId}
              shortlistStore={shortlistStore}
              id={`favoriteActivity${activity.id}`}
              activityGroup={activityGroup}
            />
          </UitkLayoutPosition>
        </UitkFigure>
      </UitkLayoutPosition>
      {isVerticalLayout ? (
        <UitkCardContentSection>
          <ActivitySpannedTileCardTitle
            activity={activity}
            isInCarousel={isInCarousel}
            isVerticalLayout={isVerticalLayout}
            titleLines={titleLines}
          />
        </UitkCardContentSection>
      ) : null}
    </>
  );
};
